import type { ProductNoEdibleInfo } from "@dransay/api";

export function ProductCardTerpenes({
	terpenes = [],
}: Pick<ProductNoEdibleInfo, "terpenes">) {
	return (
		<div className="flex items-center max-w-6/12">
			<div
				className="h-4 w-1 rounded-full"
				style={{ backgroundColor: terpenes[0]?.color }}
			/>

			<p className="h-5 ml-1.5 capitalize text-body-sm text-gray-700 truncate">
				{terpenes[0]?.name}
			</p>
		</div>
	);
}
